import * as React from "react";

import { Input, Form, Button, Radio, Select } from "antd";

import { Page, Spinner } from "src/components/common";

import pickListAPI from "./pickListAPI";

import PickListContext from "src/context/pickListContext";

import { Validation } from "src/common/utils";
import { toast } from "react-toastify";

interface IProps {
	actions: any;
	history: any;
	match: any;
}

interface IState {
	isDisabled: boolean;
	isLoading: boolean;
	pickListTypeName: string;
	pickListItem: PickListItem;
	parent: PickListItem | null;
}

class PicklistItemDetails extends React.Component<IProps, IState> {
	public static contextType = PickListContext;
	private defaultPickListItem = {
		id: undefined,
		code: "",
		description: "",
		parentId: undefined,
		isActive: undefined,
		isDefault: false,
		value1: undefined,
		value2: undefined,
		lastModified: undefined,
	};
	constructor(props: IProps) {
		super(props);
		this.state = {
			isLoading: true,
			isDisabled: false,
			pickListTypeName: "",
			pickListItem: this.defaultPickListItem,
			parent: null,
		};
	}
	public componentDidMount() {
		const picklistItemId = this.props.match.params.pickListItemId;
		if (picklistItemId !== "0") {
			pickListAPI.getPickListItem(picklistItemId).then((resp: PickListItem) => {
				const foundValue: PickListType = this.context.pickListTypes.find(
					(pType: PickListType) => pType.id === resp.pickListTypeId!
				);
				const parent = this.context.pickListItems.find(
					(pItem: PickListItem) => pItem.id === resp.parentId
				);
				if (foundValue) {
					this.setState({ pickListTypeName: foundValue.description!, parent });
				}

				this.setState({ pickListItem: resp, isLoading: false });
			});
		}
	}

	public render() {
		const validPickListItem = {
			code: Validation.validateStringIsNotEmpty(
				this.state.pickListItem.code!,
				"Enter a picklist item code"
			),
			description: Validation.validateStringIsNotEmpty(
				this.state.pickListItem.description!,
				"Enter a picklist item description"
			),
			isActive: Validation.validateIsActive(this.state.pickListItem.isActive!),
		};

		const pickListItemId = this.props.match.params.pickListItemId;

		const { pickListTypeName } = this.state;

		return this.state.isLoading !== false ? (
			<Spinner size="full-page" />
		) : (
			<Page>
				<div className="form-group">
					<h2>{`${pickListItemId === "0" ? "Add" : "Edit"} ${
						pickListTypeName.length > 0 ? pickListTypeName : "picklist"
					} items`}</h2>
					<div className="row">
						<div className="ml-3 mt-2 col-md-3">
							<Form.Item
								hasFeedback={true}
								help={validPickListItem.code.message}
								validateStatus={validPickListItem.code.validationStatus}
								label="Code"
							>
								<Input
									name="code"
									id="name"
									disabled={this.state.isDisabled}
									onChange={this.pickListItemChange}
									value={this.state.pickListItem.code}
								/>
							</Form.Item>
						</div>
						<div className="ml-1 mt-2 col-md-3">
							<Form.Item
								hasFeedback={true}
								help={validPickListItem.code.message}
								validateStatus={validPickListItem.description.validationStatus}
								label="Description"
							>
								<Input
									name="description"
									id="description"
									placeholder="Enter a picklist description"
									onChange={this.pickListItemChange}
									value={this.state.pickListItem.description}
								/>
							</Form.Item>
						</div>
						<div className="ml-1 mt-2 col-md-3">
							<Form.Item
								hasFeedback={true}
								help={validPickListItem.isActive.message}
								validateStatus={validPickListItem.isActive.validationStatus}
								label="isActive"
							>
								<Radio.Group
									name="isActive"
									onChange={this.pickListItemChange}
									value={this.state.pickListItem.isActive}
								>
									<Radio value={true}>Active</Radio>
									<Radio value={false}>InActive</Radio>
								</Radio.Group>
							</Form.Item>
						</div>
					</div>
					<div className="row">
						<div className="ml-3 mt-2 col-md-3">
							<Form.Item hasFeedback={true} label="Parent PickList Item">
								<Select
									value={this.state.parent && this.state.parent.description}
									onChange={this.selectParent}
								>
									{this.context.pickListItems
										.filter(
											(pItem: PickListItemResponseDTO) =>
												pItem.pickListTypeId !==
												this.state.pickListItem.pickListTypeId
										)
										.map((pItem: PickListItemResponseDTO) => (
											<Select.Option key={`${pItem.id}`}>
												{pItem.description}
											</Select.Option>
										))}
								</Select>
							</Form.Item>
						</div>
					</div>
					<div className="form-group col-md-3">
						<Button
							type="primary"
							htmlType="submit"
							onClick={this.onSubmit}
							disabled={!this.isValid(validPickListItem)}
						>
							Save
						</Button>
						<Button type="primary" onClick={this.sendToPreviousPage}>
							Cancel
						</Button>
					</div>
				</div>
			</Page>
		);
	}

	private selectParent = (e: any) => {
		const parent = this.context.pickListItems.find(
			(pItem: PickListItem) => pItem.id === Number(e)
		);
		this.setState({ parent });
	};

	private pickListItemChange = (e: any) => {
		let value = e.target.value!;
		if (value === "true") {
			value = true;
		}
		if (value === "false") {
			value = false;
		}
		let name = e.target.name;
		if (e.target.type === "radio") {
			value = value;
		} else if (e.target.type === "checkbox") {
			if (e.target.data !== undefined) {
				// If there's data then it's a checkbox group
				if (e.target.data.singleSelect) {
					value = value;
				} else {
					// Don't split if single value
					if (value === "") {
						value = [];
					} else {
						value = value.split(",");
					}
				}
				name = e.target.data.name;
			} else {
				value = e.target.checked;
			}
		}
		const pickListItem = {
			...this.state.pickListItem,
			[name]: value,
		};
		this.setState({ pickListItem });
	};

	private sendToPreviousPage = () => {
		this.props.history.push(
			`/admin/pick-lists/${this.props.match.params.pickListTypeId}/pick-list-items`
		);
	};

	private onSubmit = () => {
		let message = "updated pick list item";

		const newPickListItem = {
			...this.state.pickListItem,
			pickListTypeId: Number(this.props.match.params.pickListTypeId),
			isDefault: false,
			id:
				this.state.pickListItem.id !== undefined
					? this.state.pickListItem.id
					: undefined,
			parentId: this.state.parent && this.state.parent.id,
		} as PickListItemRequest;

		if (newPickListItem.id === undefined) {
			message = "Added new pick list item";
		}

		pickListAPI
			.savePickListItem(newPickListItem)
			.then(() => toast.success(message))
			.then(() =>
				this.props.history.push(
					`/admin/pick-lists/${this.props.match.params.pickListTypeId}/pick-list-items`
				)
			);
	};

	private isValid = (validPickListItem: any) => {
		const validateValues: string[] = Object.keys(validPickListItem).map(
			(key) => validPickListItem[key].validationStatus
		);
		return Validation.isValid(validateValues);
	};
}

export default PicklistItemDetails;
